/**
 * Registro tipado de rutas. Los coordinators construyen destinos desde acá
 * (`routes.foo.detail(id)`) en vez de hardcodear strings: así un coordinator
 * puede navegar a otro módulo sin acoplarse a su path literal.
 *
 * Convención: cada feature agrega su sub-objeto (`foo: { list, detail }`).
 */
export const routes = {
  home: () => '/',
  /** La dirección de una nota la arma el server (`NotaPublicaCard.path`): no se re-deriva acá. */
  nota: (path: string) => path,
  categoria: (urlKey: string) => `/${urlKey}`,
  buscar: (q?: string) => (q ? `/buscar?q=${encodeURIComponent(q)}` : '/buscar'),
} as const;
